(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-saving-services"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".fall-saving-services .swiper-container").forEach(function (container) {
    new Swiper(container, {
      slidesPerView: 1.2,
      spaceBetween: 15,
      breakpoints: {
        0: {
          enabled: true,   // 👈 mobile: enable slider
          slidesPerView: 1.2,
          spaceBetween: 15
        },
        769: {
          enabled: false,  // 👈 desktop: disable slider, fallback to grid
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
